import type {InjectionKey, DeepReadonly, Ref} from 'vue'
import type {LoanFundingAccount} from '@/common/services/Loan/LoanFundingAccountsService'
import type {PlaidItemAccount} from '@/common/data/PlaidAccount'
import type {SimpleFinicityAccountWithBalance} from '@/common/services/Finicity/FinicityService'
import type {BillingAddress, IFundingACH, IFundingCreditCard} from '@/common/models/IFunding'
import type {InternalTransferAdmin} from "@/common/services/internalTransfers/internalTransferAdminService";

interface FundingStateInjection {
    values: {
        addressList: DeepReadonly<Ref<Array<BillingAddress>>>
        channel: DeepReadonly<Ref<'branch' | 'open'>>
        selectedAddress?: DeepReadonly<Ref<BillingAddress | undefined>>
        fundingAmount: DeepReadonly<Ref<string | undefined>>
        internalAccount: DeepReadonly<Ref<LoanFundingAccount | undefined>>
        plaidAccount: DeepReadonly<Ref<PlaidItemAccount | undefined>>
        finicityAccount: DeepReadonly<Ref<SimpleFinicityAccountWithBalance | undefined>>
        fundingSource: DeepReadonly<Ref<string | undefined>>
        creditCardInformation: DeepReadonly<Ref<IFundingCreditCard>>
        achInformation: DeepReadonly<Ref<IFundingACH>>
    },
    methods: {
        updateFundingAmount: (value: string | undefined) => void
        updateInternalAccount: (value: LoanFundingAccount | undefined) => void
        updatePlaidAccount: (value: PlaidItemAccount | undefined) => void
        updateFinicityAccount: (value: SimpleFinicityAccountWithBalance | undefined) => void
        updateFundingSource: (value: string | undefined) => void
        updateCreditCardInformation: (value: IFundingCreditCard) => void
        updateAchInformation: (value: IFundingACH) => void
        updateSelectedAddress: (billingAddress: BillingAddress | undefined) => void
        addToAddressList: (billingAddress: BillingAddress) => void
        getInternalTransfersConfig: (accountTypeId: number) => Promise<InternalTransferAdmin>
    }
}

export const FUNDING_STATE_INJECTION: InjectionKey<FundingStateInjection> = Symbol('funding-state-injection')